import dayjs from 'dayjs';
import { useCallback } from 'react';

const usePrepareOutputData = () => {
  return useCallback((formData) => {
    return {
      title_sk: formData.title_sk,
      title_en: formData.title_en || null,
      slug_sk: formData.slug_sk,
      slug_en: formData.slug_en || null,
      content_sk: formData.content_sk,
      content_en: formData.content_en || null,
      valid_from: dayjs(formData.valid_from).format(),
      created_at: formData.created_at ? dayjs(formData.created_at).format() : undefined,
      top_to: (formData.top_to && dayjs(formData.top_to).format()) || null,
      image_name: formData.image_name,
      person_id: formData.person_id,
      is_top: formData.is_top,
      display_sk: formData.display_sk,
      display_en: formData.display_en,
      categories: formData.categories,
      es_date: dayjs().format(),
    };
  }, []);
};

export default usePrepareOutputData;
